import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeedbackComponent } from './feedback.component';
import { AuthGuard }      from '../shared/auth.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      { path: 'feedback', component: FeedbackComponent,  canActivate: [AuthGuard] }
    ])
  ],
  exports: [RouterModule]
})
export class FeedbackRoutingModule { 

  
}
